/** Satu-satunya path yang boleh menampilkan form login admin. */
export const ADMIN_LOGIN_PATH = '/management';

/** Redirect aman bila akses admin/panel tanpa session (jangan bocorkan login). */
export const UNAUTH_ADMIN_REDIRECT = '/';

/** Path publik yang sengaja disembunyikan agar tidak membuka form login. */
export const BLOCKED_LOGIN_ALIASES = [
  '/login',
  '/Login',
  '/LOGIN',
  '/signin',
  '/sign-in',
  '/auth',
  '/admin/login',
];

export function isAdminLoginPath(pathname = '') {
  const normalized = String(pathname).replace(/\/+$/, '') || '/';
  return normalized === ADMIN_LOGIN_PATH;
}
